<template>
	<div class="news">
		<div class="section" id="social">
			<div class="container-desktop pad-l">
				<h2 class="section-title"></h2>

				<div class="instagram-feed">
					<InstagramCard v-for="(data, i) in feed.slice(0, numMedia)" :key="i" :data="data"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import InstagramCard from './InstagramCard'

export default {
	name: 'social',

	components: {
		InstagramCard
	},

	data() {

		return {
			feed: [],

			numMedia: 6
		}
	},

	methods: {
		/**
		 * 
		 */
		async loadFeed() {
			
			try
			{
				// Fetch data
				const uri = `https://www.instagram.com/eximus_performance/?__a=1`
				let req = await fetch(uri)
				let res = await req.json()
				let media = res.graphql.user.edge_owner_to_timeline_media
				media = media.edges.map(({node}) => {

					return {
						id: node.id,
						src: node.thumbnail_src,
						title: node.edge_media_to_caption.edges[0].node.text,
						href: 'https://www.instagram.com/p/' + node.shortcode,
						likes: node.edge_liked_by.count,
						comments: node.edge_media_to_comment.count
					}
				})
				
				this.feed = media
			}
			catch (error)
			{
				// console.error(error)
			}
		}
	},

	created() {

		this.loadFeed()
	}
}
</script>

<style lang="stylus" scoped>
.instagram-feed
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 0.8em

	@media (max-width: unit(media-phone-max, px))
		grid-template-columns 1fr
</style>